import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/support/_layout/')({
  component: () => null, // La lista la renderizza il layout parent.
});
